import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Upload,
  Icon,
  Modal,
  Button,
  Spin,
  Input,
  Select,
  Checkbox,
} from 'antd';
import {
  MISSATGE_SPIN_ALTA_FOTO,
  TITOL_PUJAR_FOTOS,
  MIDA_MAX_FOTO_IND_FENOFASE_VARIOS_BYTES,
  NUM_MAX_FOTOS_FENOFASES,
  MISSATGE_LONGITUD_NOM_FITXER_PERMESA,
  MISSATGE_USUARI_NO_ACTIU,
} from '../../constantsFormularis';
import styles from './IntroduccioPujarFotos.module.css';
import { setTitolApartat, errorConsultaServidor } from '../../actions';
import { rutaObservacionsIntroduccio } from '../../routes';
import {
  extensionsPermesesEnString,
  fitxerTipusNoPermes,
} from '../../utils/gestioImatges';
import configuracio from '../../configuracioEntorns';
import {
  crearNotificacioFotoSuperaMidaPermesa,
  crearNotificacioFotoTipusNoPermes,
  crearNotificacioFotoError,
  crearNotificacioSuccess,
  crearNotificacioError,
  crearNotificacioNomFitxerMidaPermesa,
  crearNotificacioFitxerIncorrecte,
  crearNotificacioNomFitxerRepetit,
} from '../../utils/notificacio';
import fotoNoTrobada from '../../images/fotoNoTrobada.jpg';
import {
  fetchCrearFotosObservador,
  fetchObtenirDadesUsuariPerIdObservador,
} from '../../actions/consultesServidor';
import {
  getIdObservadorIntroduccio,
  getObservadorsAsArray,
  getUsuari,
} from '../../reducers';

const SEPARADOR = '#%';
const unitatImatge = 'MB';
const missatgeErrorDescripcio =
  "Torni a fer l'enviament de les fotos amb connexió a internet sense interrupcions";

const converteixBytesAMB = (midaEnBytes) => {
  return (midaEnBytes / 1000 / 1000).toFixed(2);
};

const midaMaximaFotosEnMB = converteixBytesAMB(
  MIDA_MAX_FOTO_IND_FENOFASE_VARIOS_BYTES
);

const fitxerSuperaMidaMaximaPermesa = (midaFitxerEnMB, midaMaximaFotosEnMB) => {
  return parseFloat(midaFitxerEnMB) > parseFloat(midaMaximaFotosEnMB);
};

class IntroduccioPujarFotos extends Component {
  state = {
    previewVisible: false,
    previewImage: '',
    uploading: false,
    fileList: [],
    observador: {},
    checkedAltres: false,
    tornarASeleccionar: false,
    descripcio: '',
    idEspecie: null,
    idFenofase: null,
    nomEspecie: null,
    nomFenofase: null,
    usuariNoActiu: false,
  };

  componentDidMount() {
    this.props.setTitolApartat(TITOL_PUJAR_FOTOS);
  }

  handleOnChangeEspecie = (opcioSeleccionada) => {
    const idEspecie = opcioSeleccionada.substr(
      opcioSeleccionada.indexOf(SEPARADOR) + SEPARADOR.length
    );
    const nomEspecie = opcioSeleccionada.substr(
      0,
      opcioSeleccionada.indexOf(SEPARADOR)
    );
    const constIdEspecieInt = isNaN(parseInt(idEspecie))
      ? 0
      : parseInt(idEspecie);

    this.setState({
      idEspecie: constIdEspecieInt,
    });
    this.setState({ nomEspecie: nomEspecie });

    const { fenofases } = this.props;
    const fenofasesArray = Object.keys(fenofases).map((key) => ({
      nom: fenofases[key].nom,
      id: parseInt(key),
      idEspecie: parseInt(fenofases[key].idEspecie),
    }));

    const fenofasesEspecieSeleccionada = fenofasesArray.filter((fenofase) => {
      return constIdEspecieInt === fenofase.idEspecie;
    });

    if (fenofasesEspecieSeleccionada.length === 1) {
      this.setState({ idFenofase: fenofasesEspecieSeleccionada[0].id });
      this.setState({ nomFenofase: fenofasesEspecieSeleccionada[0].nom });
    }
  };

  handleOnChangeFenofase = (opcioSeleccionada) => {
    const idFenofase = opcioSeleccionada.substr(
      opcioSeleccionada.indexOf(SEPARADOR) + SEPARADOR.length
    );
    const nomFenofase = opcioSeleccionada.substr(
      0,
      opcioSeleccionada.indexOf(SEPARADOR)
    );

    const constIdFenofaseInt = isNaN(parseInt(idFenofase))
      ? 0
      : parseInt(idFenofase);

    this.setState({
      idFenofase: constIdFenofaseInt,
    });
    this.setState({ nomFenofase: nomFenofase });
  };

  handleOnChangeAltres = (e) => {
    this.setState({
      checkedAltres: e.target.checked,
      idEspecie: null,
      idFenofase: null,
      nomEspecie: null,
      nomFenofase: null,
    });
  };

  handleOnChangeTornarASeleccionar = (e) => {
    this.setState({
      tornarASeleccionar: e.target.checked,
    });
  };

  ordenarArrayObjectesDesc = (a, b) => {
    if (a.nomEspecie < b.nomEspecie) {
      return -1;
    }
    if (a.nomEspecie > b.nomEspecie) {
      return 1;
    }
    return 0;
  };

  getTotesFenofases = (fenofases, idEspecie) => {
    return Array.isArray(fenofases) && idEspecie ? fenofases : [];
  };

  getListaFenofasesIdEspecie = (fenofases, idEspecie) => {
    if (!fenofases || !idEspecie) {
      return [];
    }
    return fenofases.filter((fenofase) => {
      return fenofase.idEspecie === idEspecie;
    });
  };

  renderitzarSelectorEspecie = () => {
    const { Option, OptGroup } = Select;
    const { classes, especies } = this.props;
    const { idEspecie, checkedAltres } = this.state;
    const textSelEspecie = 'Selecciona una espècie...';
    const especiesArray = Object.keys(especies).map((key) => especies[key]);
    const classesArray = Object.keys(classes).map((key) => ({
      nom: classes[key].nomClasse,
      id: parseInt(key),
    }));
    const llistaEspecieSeleccionada = especiesArray.filter((especie) => {
      return especie.idEspecie === idEspecie;
    });

    const nomEspecieSeleccionada =
      llistaEspecieSeleccionada && llistaEspecieSeleccionada.length > 0
        ? llistaEspecieSeleccionada[0].nomEspecie
        : '';

    const valor =
      nomEspecieSeleccionada && idEspecie
        ? nomEspecieSeleccionada + SEPARADOR + idEspecie
        : textSelEspecie;

    return (
      <div
        className={
          this.state.checkedAltres || valor === textSelEspecie
            ? styles.visualitzacioSelector
            : styles.visualitzacioSelector + ' ' + styles.Selected
        }
      >
        <label htmlFor="id-especie">Espècie</label>
        <Select
          showSearch
          style={{ width: 250, maxHeight: 100 }}
          id="id-especie"
          onChange={this.handleOnChangeEspecie}
          value={valor}
          disabled={checkedAltres}
        >
          {classesArray.map((classe) => (
            <OptGroup key={classe.id} label={classe.nom}>
              {especiesArray
                .filter((especie) => {
                  return especie.idClasse === classe.id;
                })
                .slice()
                .sort(this.ordenarArrayObjectesDesc)
                .map((especie) => (
                  <Option
                    key={especie.idEspecie}
                    value={especie.nomEspecie + SEPARADOR + especie.idEspecie}
                  >
                    {especie.nomEspecie}
                  </Option>
                ))}
            </OptGroup>
          ))}
        </Select>
      </div>
    );
  };

  renderitzarSelectorFenofase = () => {
    const { Option } = Select;
    const { fenofases } = this.props;
    const { idEspecie, idFenofase, checkedAltres } = this.state;
    const textSelFenofase = 'Seleccionar la fenofase...';
    const fenofasesArray = Object.keys(fenofases).map((key) => ({
      nom: fenofases[key].nom,
      id: parseInt(key),
      idEspecie: parseInt(fenofases[key].idEspecie),
    }));

    const totesFenofases = this.getTotesFenofases(fenofasesArray, idEspecie);

    const listaFenofasesIdEspecie = this.getListaFenofasesIdEspecie(
      totesFenofases,
      idEspecie
    );

    const llistaFenofaseSeleccionada =
      fenofasesArray && fenofasesArray.length
        ? fenofasesArray.filter((fenofase) => {
            return fenofase.id === idFenofase;
          })
        : [];

    const nomFenofaseSeleccionada =
      llistaFenofaseSeleccionada && llistaFenofaseSeleccionada.length > 0
        ? llistaFenofaseSeleccionada[0].nom
        : '';

    const valor =
      nomFenofaseSeleccionada && idFenofase
        ? nomFenofaseSeleccionada + SEPARADOR + idFenofase
        : idEspecie && listaFenofasesIdEspecie.length === 1
        ? listaFenofasesIdEspecie[0].nom +
          SEPARADOR +
          listaFenofasesIdEspecie[0].id
        : textSelFenofase;

    return (
      <div
        className={
          this.state.checkedAltres || valor === textSelFenofase
            ? styles.visualitzacioSelector
            : styles.visualitzacioSelector + ' ' + styles.Selected
        }
      >
        <label htmlFor="id-fenofase">Fenofase</label>

        <Select
          showSearch
          style={{ width: 250, maxHeight: 100 }}
          id="id-fenofase"
          onChange={this.handleOnChangeFenofase}
          value={valor}
          disabled={checkedAltres}
        >
          {listaFenofasesIdEspecie.map((fenofase) => {
            return (
              <Option
                key={fenofase.id}
                value={fenofase.nom + SEPARADOR + fenofase.id}
              >
                {fenofase.nom}
              </Option>
            );
          })}
        </Select>
      </div>
    );
  };

  renderitzarSelectorAltres = () => {
    return (
      <div className={styles.altres}>
        <Checkbox
          checked={this.state.checkedAltres}
          onChange={this.handleOnChangeAltres}
        >
          Altres fotografies d'interès fenològic
        </Checkbox>
      </div>
    );
  };

  renderitzarSelectorFotos = () => {
    const { fileList, previewVisible, previewImage } = this.state;
    const uploadButton = (
      <div className={styles.triaFotos}>
        <Icon type="plus" />
        <div>Afegir foto</div>
      </div>
    );

    const textTamanyNombreFotos = `Pots seleccionar fins a ${NUM_MAX_FOTOS_FENOFASES} imatges de l'opció triada en el pas anterior. S'admeten fitxers PNG i JPG que no superin la mida de: ${midaMaximaFotosEnMB} MB cadascun`;

    return (
      <div className={styles.altaForm}>
        <h2 className={styles.h2}>Pas 2: escollir fotos</h2>
        <p>{textTamanyNombreFotos}</p>
        <Upload
          listType="picture-card"
          fileList={fileList}
          accept={extensionsPermesesEnString}
          onPreview={this.handlePreview}
          onChange={this.handleChangeFoto}
          beforeUpload={this.beforeUpload}
        >
          {fileList.length >= NUM_MAX_FOTOS_FENOFASES ? null : uploadButton}
        </Upload>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    );
  };

  renderitzarDescripcioFotos = () => {
    const { TextArea } = Input;
    return (
      <div className={styles.descripcioFotos}>
        <h2 className={styles.h2}>
          Pas 3: opcionalment pots afegir un text descriptiu
        </h2>
        <label htmlFor="descripcioFoto">Descripció</label>
        <TextArea
          id="descripcioFoto"
          value={this.state.descripcio}
          onChange={(event) => {
            const valor = event.target.value;
            this.handleChangeDescripcio(valor);
          }}
        />
      </div>
    );
  };

  renderitzarBotoEnviamentICheckTornarAEnviar = () => {
    const {
      fileList,
      uploading,
      nomEspecie,
      nomFenofase,
      checkedAltres,
    } = this.state;
    const ocultarBoto =
      (nomEspecie && nomFenofase) || checkedAltres ? false : true;

    return (
      <div className={styles.btnEnviar}>
        <Button
          type="primary"
          size="large"
          onClick={this.handleUpload}
          disabled={
            fileList.length === 0 ||
            fileList[0].name === 'Sense Foto' ||
            ocultarBoto
          }
          loading={uploading}
          style={{ marginTop: 16, marginRight: 16 }}
        >
          {uploading
            ? 'Uploading'
            : this.state.tornarASeleccionar
            ? 'Enviar'
            : 'Enviar i tornar'}
        </Button>

        <Checkbox
          checked={this.state.tornarASeleccionar}
          onChange={this.handleOnChangeTornarASeleccionar}
          disabled={
            fileList.length === 0 ||
            fileList[0].name === 'Sense Foto' ||
            ocultarBoto
          }
          className={styles.mesFotos}
        >
          Vull enviar més fotografies
        </Checkbox>
      </div>
    );
  };

  renderitzarBotoTornar = () => {
    return (
      <Link
        className={styles.botoTornar}
        to={{
          pathname: rutaObservacionsIntroduccio,
          query: { render: false },
        }}
      >
        <Button icon="left">Tornar</Button>
      </Link>
    );
  };

  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  checkJpegImage = (base64string) => {
    var src = base64string;
    var imageData = Uint8Array.from(
      atob(src.replace('data:image/jpeg;base64,', '')),
      (c) => c.charCodeAt(0)
    );
    var imageCorrupted =
      imageData[imageData.length - 1] === 217 &&
      imageData[imageData.length - 2] === 255;

    return imageCorrupted;
  };

  checkPNGImage = (base64string) => {
    var src = base64string;
    var imageData = Uint8Array.from(
      atob(src.replace('data:image/png;base64,', '')),
      (c) => c.charCodeAt(0)
    );
    var sequence = [0, 0, 0, 0, 73, 69, 78, 68, 174, 66, 96, 130]; // in hex:

    //check last 12 elements of array so they contains needed values
    for (var i = 12; i > 0; i--) {
      if (imageData[imageData.length - i] !== sequence[12 - i]) {
        return false;
      }
    }

    return true;
  };

  getNomObservador = () => {
    const { observadors, idObservadorSeleccionat, location } = this.props;

    const llistaObservadorSeleccionat = observadors.filter((observador) => {
      return observador.id === idObservadorSeleccionat;
    });

    return llistaObservadorSeleccionat && llistaObservadorSeleccionat.length > 0
      ? llistaObservadorSeleccionat[0].nom +
          ' ' +
          llistaObservadorSeleccionat[0].cognom1 +
          ' ' +
          llistaObservadorSeleccionat[0].cognom2
      : location.state.observador;
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };

  fotosCorrectes = (fileList) => {
    fileList.forEach(async (file) => {
      const foto = file.originFileObj;
      let estatImatge;

      const imageData = await this.getBase64(foto);

      if (foto.type === 'image/jpeg') {
        estatImatge = this.checkJpegImage(imageData);
      } else if (foto.type === 'image/png') {
        estatImatge = this.checkPNGImage(imageData);
      }

      if (estatImatge === false) {
        return estatImatge;
      }
    });
    return true;
  };

  obtenirFormData = (fileList, dades) => {
    let formData = new FormData();
    fileList.forEach((file) => {
      formData.append('fotosCreades', file.originFileObj);
    });

    formData.append('dades', JSON.stringify(dades));
    return formData;
  };

  missatgeUsuariErrorEspaiLimirSuperat = (objecteError) => {
    const missatgeUsuari =
      objecteError.jse_cause && objecteError.jse_cause.code === 'ENOSPC'
        ? "S'ha superat l'espai màxim d'emmagatzematge de fotografies. Provi fer-ho passat uns dies."
        : objecteError.message;
    return missatgeUsuari;
  };

  gestioError = (error, tipusError) => {
    this.setState({ usuariNoActiu: true });
    this.props.errorConsultaServidor(error, tipusError);
  };

  handleUpload = async () => {
    const dadesUsuari = await fetchObtenirDadesUsuariPerIdObservador(
      this.props.usuari.idObservador
    ).catch((error) => this.gestioError('Avís Error', error));

    if (dadesUsuari) {
      if (!dadesUsuari.actiu) {
        this.gestioError('Avís Error', MISSATGE_USUARI_NO_ACTIU);
      } else {
        const { fileList } = this.state;
        const { history } = this.props;
        if (!fileList || !fileList[0] || !this.fotosCorrectes(fileList)) {
          crearNotificacioFotoError();
          return;
        }

        const dades = {
          nomObservador: this.getNomObservador(),
          nomEspecie: this.state.nomEspecie,
          nomFenofase: this.state.nomFenofase,
          checkedAltres: this.state.checkedAltres,
          descripcioFoto: this.state.descripcio ? this.state.descripcio : '',
        };

        const dadesAEnviar = this.obtenirFormData(fileList, dades);

        this.setState({
          uploading: true,
        });

        const promesa = fetchCrearFotosObservador(dadesAEnviar);

        const missatgeNotificacioExit =
          fileList.length === 0
            ? `Foto pujada correctament`
            : `Fotos pujades correctament`;
        const missatgeNotificacioError =
          fileList.length === 0 ? 'Error pujant foto' : 'Error pujant fotos';
        let missatgeUsuari = '';
        return promesa.then(
          (result) => {
            this.setState({
              fileList: [],
              checkedAltres: false,
              descripcio: '',
              uploading: false,
              idEspecie: null,
              idFenofase: null,
              nomEspecie: null,
              nomFenofase: null,
            });

            if (result && result.message) {
              const missatgeUsuari = this.missatgeUsuariErrorEspaiLimirSuperat(
                result
              );
              return crearNotificacioError(
                missatgeNotificacioError,
                missatgeUsuari
              );
            }
            crearNotificacioSuccess(missatgeNotificacioExit);

            if (!this.state.tornarASeleccionar) {
              history.push({
                pathname: rutaObservacionsIntroduccio,
              });
            }
            this.setState({
              tornarASeleccionar: false,
            });
          },
          (errorServidor) => {
            this.setState({
              uploading: false,
            });
            if (errorServidor.message) {
              missatgeUsuari = this.missatgeUsuariErrorEspaiLimirSuperat(
                errorServidor
              );
            } else
              missatgeUsuari = errorServidor + '. ' + missatgeErrorDescripcio;

            crearNotificacioError(missatgeNotificacioError, missatgeUsuari);
          }
        );
      }
    }
  };

  beforeUpload = () => {
    return false;
  };

  handleChangeDescripcio = (value) => {
    this.setState({
      descripcio: value,
    });
  };

  handleChangeFoto = ({ file, fileList }) => {
    if (fileList && fileList.length > 0) {
      const fitxer = fileList[fileList.length - 1].originFileObj;
      const midaFitxerEnMB = converteixBytesAMB(fitxer.size);
      const tipusFitxer = fitxer.type;

      if (fitxer.status === 'error') {
        crearNotificacioFitxerIncorrecte();
        return;
      }

      const fitxerRepetit = fileList.filter(
        (element) => element.name === fitxer.name
      );

      if (fitxerRepetit.length > 1) {
        crearNotificacioNomFitxerRepetit(fitxer.name);
        return;
      }

      if (fitxer.name.length > MISSATGE_LONGITUD_NOM_FITXER_PERMESA) {
        crearNotificacioNomFitxerMidaPermesa(
          fitxer.name,
          MISSATGE_LONGITUD_NOM_FITXER_PERMESA
        );
        return;
      }

      if (fitxerTipusNoPermes(tipusFitxer)) {
        crearNotificacioFotoTipusNoPermes();
        return;
      }

      if (fitxerSuperaMidaMaximaPermesa(midaFitxerEnMB, midaMaximaFotosEnMB)) {
        crearNotificacioFotoSuperaMidaPermesa(
          midaFitxerEnMB,
          unitatImatge,
          midaMaximaFotosEnMB
        );
        return;
      }

      if (fitxer.status === 'error') {
        fileList = [
          {
            uid: '-1',
            name: 'Sense Foto',
            status: 'error',
            url: fotoNoTrobada,
          },
        ];
      }
    }

    this.setState({ fileList });
  };

  render() {
    const { usuariNoActiu, uploading } = this.state;

    if (usuariNoActiu) {
      const urlBase = configuracio.ruta;
      return <Redirect to={`${urlBase}/login`} />;
    }

    return (
      <Spin spinning={uploading} tip={MISSATGE_SPIN_ALTA_FOTO} delay={300}>
        <div className={styles.pujarFotos}>
          <div>
            <h2 className={styles.h2}>Pas 1: seleccionar individu</h2>
            <p>
              Cal seleccionar una espècie i fenofase, o bé seleccionar l'opció
              'altres fotos...'
            </p>

            {this.renderitzarSelectorEspecie()}
            {this.renderitzarSelectorFenofase()}
            {this.renderitzarSelectorAltres()}
            {this.renderitzarSelectorFotos()}
            {this.renderitzarDescripcioFotos()}
            {this.renderitzarBotoEnviamentICheckTornarAEnviar()}
          </div>

          <Link
            className={styles.botoTornar}
            to={{
              pathname: rutaObservacionsIntroduccio,
              query: { render: false },
            }}
          >
            <Button icon="left">Tornar</Button>
          </Link>
        </div>
      </Spin>
    );
  }
}

IntroduccioPujarFotos.propTypes = {
  setTitolApartat: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func,
  history: PropTypes.object,
  usuari: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    idObservadorSeleccionat: getIdObservadorIntroduccio(state),
    observadors: getObservadorsAsArray(state),
    especies: state.especies,
    fenofases: state.fenofases,
    classes: state.classes.introduccio,
    usuari: getUsuari(state),
  };
};

const mapDispatchToProps = {
  setTitolApartat,
  errorConsultaServidor,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IntroduccioPujarFotos);
